import { render, staticRenderFns } from "./SegmentationResult.vue?vue&type=template&id=233b1961"
import script from "./SegmentationResult.vue?vue&type=script&lang=js"
export * from "./SegmentationResult.vue?vue&type=script&lang=js"
import style0 from "./SegmentationResult.vue?vue&type=style&index=0&id=233b1961&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports